import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { api } from './api';

export interface PersonalToken {
  id: number;
  name: string;
  createdAt: string;
  lastUsedAt: string | null;
  revokedAt: string | null;
}

const tokensKey = ['account', 'tokens'] as const;

export function usePersonalTokens() {
  return useQuery({
    queryKey: tokensKey,
    queryFn: () => api.get<PersonalToken[]>('/api/account/tokens'),
  });
}

/** The returned token is shown once; only its hash is stored. */
export function useCreatePersonalToken() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (name: string) => api.post<{ id: number; token: string }>('/api/account/tokens', { name }),
    onSuccess: () => qc.invalidateQueries({ queryKey: tokensKey }),
  });
}

export function useRevokePersonalToken() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => api.delete<unknown>(`/api/account/tokens/${id}`),
    onSuccess: () => qc.invalidateQueries({ queryKey: tokensKey }),
  });
}
